import type { BizIconProps } from './base';
import BizIconSvg from './base';

/**
 * IconHandUp —— 举手（请求组长支援）：**一只手**（四指 + 拇指 + 掌心），不是完整人形。
 * Arco 线性图标里没有「举手/求助」语义；用可一眼读懂的张开手掌，避免人形图标在 16px 顶栏里
 * 只剩一个「小人」、丢掉「举手请示」的动作含义。
 */
export default function IconHandUp(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      {/* 掌心 + 腕部：U 形托住四指 */}
      <path d="M4.6 8.9v2.7a3.4 3.4 0 0 0 3.4 3.4h.1a3.4 3.4 0 0 0 3.4-3.4V8.9" />
      {/* 四指：长短错落，圆头（stroke-linecap = round） */}
      <path d="M5.7 8.9V4.5" />
      <path d="M7.6 8.9V3.5" />
      <path d="M9.5 8.9V4.1" />
      <path d="M11.4 8.9V5.4" />
      {/* 拇指：从掌根向左下伸出再回勾 */}
      <path d="M4.6 9.8 3.1 8.7a1 1 0 0 0-1.1 1.6l1.9 1.2" />
    </BizIconSvg>
  );
}
